import EAAutoCompleteInput from '../../inputs/EAAutoCompleteInput';
import { Controller } from 'react-hook-form';
import { FormControlLabel, MenuItem, Radio, RadioGroup, Select, TextField } from '@mui/material';
import EAColorIcon from '../../common/EAColorIcon';
import i18next from 'i18next';
import { LISTE_DEVISE } from './UnmanagedThirdPartyUtils';
import React from 'react';
import useStyles
  from '../../../style/js-style/containers/thirdparties/unmanagedThirdParty/CreateUnmanagedThirdPartyStyle';

export const UnmanagedInput = ({ inputType, placeholder, name, options, isRequired, formMethods, handleChangeSelect, selectedEtabType, handleEtabType }) => {
  const { classes } = useStyles();

  switch (inputType) {
    case 'select':
      return (
        <EAAutoCompleteInput
          fieldName={name}
          options={options}
          placeholder={placeholder}
          variant="outlined"
          onChange={(target) => handleChangeSelect(target, name)}
          isRequired={isRequired}
          errors={formMethods.formState.errors[name]}
          formMethodsProps={formMethods}
          style={{
            '& .MuiOutlinedInput-root': {
              border: 'none',
            },
          }}
        />
      );

    case 'radio':
      return (
        <Controller
          control={formMethods.control}
          name={name}
          render={({ field }) => (
            <RadioGroup
              row
              value={selectedEtabType}
              onChange={handleEtabType}
            >
              {options.map((option, index) => (
                <FormControlLabel
                  value={option.value}
                  key={'etabType_' + index}
                  control={
                    <Radio
                      size="small"
                      color="primary"
                      icon={<EAColorIcon icon={'input/radio-unchecked'} />}
                      checkedIcon={
                        <EAColorIcon icon={'input/radio-checked'} />
                      }
                    />
                  }
                  label={
                    <span style={{ fontSize: '14px' }}>
                          {i18next.t(
                            `unmanagedThirdParty.placeholder.etabType.${option.value}`
                          )}
                        </span>
                  }
                />
              ))}
            </RadioGroup>
          )}
        />
      );

    case 'devise':
      return (
        <div style={{ position: 'relative' }}>
          <Controller
            control={formMethods.control}
            name={name}
            isRequired={isRequired}
            rules={{
              required: isRequired ? i18next.t('infos.required') : false,
              validate: (value) =>
                value && value > 2147483647
                  ? i18next.t('unmanagedThirdParty.capitalError')
                  : undefined,
            }}
            render={({ field }) => (
              <TextField
                {...field}
                className={
                  !!formMethods.formState.errors[name]
                    ? classes.inputError
                    : classes.input
                }
                placeholder={placeholder}
                id={name}
                variant="outlined"
                error={!!formMethods.formState.errors[name]}
                fullWidth
                helperText={
                  !!formMethods.formState.errors[name]
                    ? formMethods.formState.errors[name].message
                    : ''
                }
                onChange={(e) => {
                  const cleanValue = e.target.value.replace(/\D/g, '');
                  field.onChange(cleanValue);
                }}
              />
            )}
          />
          <Controller
            control={formMethods.control}
            name={'capitalCurrency'}
            isRequired={isRequired}
            rules={
              isRequired ? { required: i18next.t('infos.required') } : {}
            }
            render={({ field }) => (
              <Select
                {...field}
                type={inputType}
                className={classes.inputDevise}
                placeholder={placeholder}
                id="capitalCurrency"
                variant="outlined"
                sx={{
                  border: 'none',
                  width: '80px',
                  position: 'absolute',
                  right: 0,
                  top: 0,
                }}
                error={!!formMethods.formState.errors[name]}
                helperText={
                  !!formMethods.formState.errors[name]
                    ? formMethods.formState.errors[name].message
                    : ''
                }
              >
                {LISTE_DEVISE.map((devise) => {
                  return { value: devise.code, label: devise.code };
                })?.map((item) => (
                  <MenuItem key={item.label} value={item.value}>
                    <span>{item.label}</span>
                  </MenuItem>
                ))}
              </Select>
            )}
          />
        </div>
      );

    default:
      return (
        <Controller
          control={formMethods.control}
          name={name}
          isRequired={isRequired}
          rules={
            isRequired ? { required: i18next.t('infos.required') } : {}
          }
          render={({ field }) => (
            <TextField
              {...field}
              type={inputType}
              className={
                !!formMethods.formState.errors[name]
                  ? classes.inputError
                  : classes.input
              }
              placeholder={placeholder}
              id="name"
              variant="outlined"
              error={!!formMethods.formState.errors[name]}
              fullWidth
              helperText={
                !!formMethods.formState.errors[name]
                  ? formMethods.formState.errors[name].message
                  : ''
              }
            />
          )}
        />
      );
  }
};